var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{attrs:{"id":"gatewayModemsGrid","title":_vm.$t('g-modems:modems'),"columns":_vm.columns,"paginated-dto":_vm.modems,"pagination":false,"disabled":!_vm.$store.getters.bscFeature(_vm.gateway, 'modem')},on:{"load":_vm.getModems}})}
var staticRenderFns = []

export { render, staticRenderFns }